"use client";

import { useEffect, useMemo } from "react";

import {
  runWidgetScripts,
  withoutScripts,
} from "./external-booking-html.scripts";

interface ExternalBookingHtmlProps {
  html: string;
  className?: string;
}

/**
 * The operator's booking widget HTML, in the place of one Book button
 * (External Booking Link, "Custom HTML" mode). It runs on the storefront's own
 * origin, not in a frame, which is why saving it needs `payments:manage`
 * (`SaveExperiencePaymentService.authorize`, operator-api).
 */
export function ExternalBookingHtml({
  html,
  className,
}: ExternalBookingHtmlProps) {
  const markup = useMemo(() => withoutScripts(html), [html]);
  useEffect(() => {
    runWidgetScripts(html);
  }, [html]);
  return (
    <div
      className={className}
      // The operator's own markup, saved only by a member with payments:manage.
      // nosemgrep: typescript.react.security.audit.react-dangerouslysetinnerhtml.react-dangerouslysetinnerhtml
      dangerouslySetInnerHTML={{ __html: markup }}
      // A vendor script may rewrite its button in place before hydration.
      suppressHydrationWarning
    />
  );
}
